import api from './api'

export interface CompanyProfile {
  id: string
  company_name: string
  legal_name?: string
  tagline?: string
  website?: string
  email?: string
  support_email?: string
  phone?: string
  whatsapp_number?: string
  address_line1?: string
  address_line2?: string
  city?: string
  state?: string
  pincode?: string
  country?: string
  gstin?: string
  pan?: string
  cin?: string
  logo_url?: string
  dark_logo_url?: string
  favicon_url?: string
  primary_color?: string
  secondary_color?: string
  accent_color?: string
  bank_name?: string
  bank_account_number?: string
  bank_ifsc?: string
  bank_branch?: string
  upi_id?: string
  invoice_header_note?: string
  invoice_footer_note?: string
  terms_and_conditions?: string
  extra_settings?: Record<string, any>
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export const companyProfileService = {
  getProfile: async (): Promise<CompanyProfile> => {
    const response = await api.get<CompanyProfile>('/admin/company-profile')
    return response.data
  },

  updateProfile: async (payload: Partial<CompanyProfile>): Promise<CompanyProfile> => {
    const response = await api.put<CompanyProfile>('/admin/company-profile', payload)
    return response.data
  },

  getPublicProfile: async (): Promise<Partial<CompanyProfile>> => {
    const response = await api.get<Partial<CompanyProfile>>('/public/company-profile')
    return response.data
  }
}
